import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import React from "react";

const SearchBox = ({
  searchText,
  setSearchText,
  teams,
  teamFilter,
  setTeamFilter,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        mb: { xs: 2, sm: 3, md: 4 },
        mt: { xs: 7, sm: 8, md: 6 },
        px: { xs: 1, sm: 2, md: 4 },
        gap: 2,
      }}
    >
      {/* Arama */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          mt: { xs: 7, sm: 8, md: 4 },
        }}
      >
        <TextField
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Personel Ara..."
          size="small"
          sx={{
            width: { xs: "100%", sm: 350, md: 400 },
            bgcolor: "#fff",
            borderRadius: 3,
            boxShadow: 2,
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "grey.500" }} />
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>

      {/* Ekip Filtresi */}
      {teams && teams.length > 0 && (
        <Box>
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{ mb: 1, color: "text.secondary" }}
          >
            Ekip
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Chip
              label="Tümü"
              onClick={() => setTeamFilter(null)}
              color={teamFilter === null ? "primary" : "default"}
              variant={teamFilter === null ? "filled" : "outlined"}
              sx={{
                fontWeight: 600,
                mb: 1,
                cursor: "pointer",
                borderColor: teamFilter === null ? "transparent" : "#8B1A1A",
                color: teamFilter === null ? "#fff" : "#8B1A1A",
              }}
            />
            {teams.map((team) => (
              <Chip
                key={team.id}
                label={team.name}
                onClick={() => setTeamFilter(team.name)}
                color={teamFilter === team.name ? "primary" : "default"}
                variant={teamFilter === team.name ? "filled" : "outlined"}
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  cursor: "pointer",
                  borderColor: teamFilter === team.name ? "transparent" : "#8B1A1A",
                  color: teamFilter === team.name ? "#fff" : "#8B1A1A",
                }}
              />
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default SearchBox;
